<app-web-navbar></app-web-navbar>
<div class="cancellation-container">
  <h1 class="fw-bold">Cancellation and Refund</h1>
  <div class="decorator mb-4"></div>
      
  <p> No Cancellation or Refunds are entertained.</p>
</div>
<app-web-footer></app-web-footer>